import { Controller } from "@hotwired/stimulus"

// Generic controller for toggling between display and edit views
export default class extends Controller {
  static targets = ["display", "form"]
  
  toggleEdit(event) {
    event.preventDefault()
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
  }
  
  cancelEdit(event) {
    event.preventDefault()
    this.formTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }
}